<template>
    <painel-component :itens="itensOne">

        <row-col-component :class-row-col="'col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12 filter-position'"
                           v-if="btnFilter">
            <button class="btn-filter" @click="filterWindow">
                <i class="filter icon"></i>
            </button>
        </row-col-component>

        <form class="mb-4 mt-5">
            <transition name="fade-in-top">
                <row-component v-if="filter">
                    <row-col-component :class-row-col="'col-xxl-5 col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12'">
                        <label>Nome:</label>
                        <input-component :type-input="'text'" v-model="formDate.name">
                        </input-component>
                    </row-col-component>

                    <row-col-component :class-row-col="'col-xxl-5 col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12'">
                        <label>Status:</label>
                        <multiselect v-model="formDate.status" :searchable="true" :options="selectInput"
                                     :noResultsText="this.$store.state.var.selectNotSearch"/>
                    </row-col-component>

                    <row-col-component :class-row-col="'col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12 mt-4'">
                        <button-one class="mx-1" @submit="submit" :icon="'search'" :nameButton="''"/>
                            <button-float class="mx-1" :itens="itensTwo" v-if="buttonCheck.create"/>
                    </row-col-component>
                </row-component>
            </transition>
        </form>

        <loder-send-component :text-title="'Carregando'" v-if="showLoder"></loder-send-component>

        <div v-else>
            <table class="table table-striped">
                <thead>
                <tr>
                    <th scope="col" style="width: 25%">Nome</th>
                    <th scope="col" style="width: 25%">Status</th>
                    <th scope="col" style="width: 25%">Saldo</th>
                    <th scope="col" style="width: 25%" v-if="buttonCheck.show || buttonCheck.edit">Ações
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(account_bank, index) in  account_banks.data" :key="index">
                    <td data-label="Nome">
                        <img v-if="account_bank.photo" :src="account_bank.photo" class="avatar__image_2">
                        <img v-else src="@/assets/img/avatar.png" alt="" class="avatar__image_2">
                        {{ account_bank.name }}
                    </td>
                    <td data-label="Status">{{ statusString(account_bank.status) }}</td>
                    <td data-label="Saldo">{{ account_bank.balance }}</td>
                    <td data-label="Ações" v-if="buttonCheck.show || buttonCheck.edit">
                        <button-show-round :route="'account-bank-show'" :id-param="account_bank.id"
                                           v-if="buttonCheck.show">
                        </button-show-round>
                        <button-edit-round :route="'account-bank-edit'" :id-param="account_bank.id"
                                           v-if="buttonCheck.edit">
                        </button-edit-round>
                    </td>
                </tr>
                </tbody>
            </table>

            <button-pagination :pagination="account_banks" :offset="3" @paginate="loadAccountsBanks"/>
        </div>

    </painel-component>
</template>

<script>
import ButtonEditRound from "@/components/buttons/ButtonEditRound";
import ButtonShowRound from "@/components/buttons/ButtonShowRound";
import PainelComponent from "@/components/dashboard/PainelComponent";
import ButtonOne from "@/components/buttons/ButtonOne";
import ButtonFloat from "@/components/buttons/ButtonFloat";
import ButtonPagination from "@/components/buttons/ButtonPagination";
import InputComponent from "@/components/form/InputComponent";
import RowComponent from "@/components/row/RowComponent";
import RowColComponent from "@/components/row/RowColComponent";
import LoderSendComponent from "@/components/LoderSendComponent";
import Multiselect from "@vueform/multiselect";

import {useToast} from "vue-toastification";

const toast = useToast();

export default {
    name: "AccountBankSearch",

    created() {
        this.$store.dispatch('updateNamePage', 'Conta Bancária')
        this.loadAccountsBanks(1)
        this.checkACL()
        if (window.innerWidth <= 991) {
            this.filter = false
            this.btnFilter = true
        }
    },

    data() {
        return {
            itensOne: {
                title: "Pesquisa",
                icon: "list alternate"
            },

            itensTwo: {
                route: "/account-bank/create",
                icon: "plus",
                name: ''
            },

            page: 1,
            pagination: [],

            formDate: {
                name: '',
                status: 1,
            },

            showLoder: true,
            searchSubmit: false,

            buttonCheck: {
                edit: false,
                create: false,
                show: false
            },

            filter: true,
            btnFilter: false,
        }
    },

    methods: {
        submit() {
            this.loadAccountsBanks(1)
            this.searchSubmit = true;
        },

        filterWindow() {
            this.filter = !this.filter
        },

        loadAccountsBanks(page) {
            this.showLoder = true
            if (!this.searchSubmit) {
                this.$store.dispatch('loadAccountsBanks', {...this.params, page})
                    .then((r) => {
                        this.showLoder = false
                        if (this.searchSubmit) {
                            this.searchSubmit = false;
                            if (r.data == '') {
                                toast.info("Nada foi encontrado com os parâmetros informados!", {timeout: 10000});
                            }
                        }
                    }).catch(() => {
                    this.showLoder = false
                    this.searchSubmit = false;
                });
            }
        },

        statusString(value) {
            if (value == 1) {
                return 'Aberto'
            }
            return 'Finalizado'
        },

        async checkACL() {
            this.$store.dispatch('ACLitens', 14)
                .then((r) => {

                    if (r.data.indexOf('account-bank-search') !== -1) {
                        this.showLoder = false

                        if (r.data.indexOf('account-bank-search') !== -1) {
                            this.buttonCheck.show = true
                        }

                        if (r.data.indexOf('account-bank-edit') !== -1) {
                            this.buttonCheck.edit = true
                        }

                        if (r.data.indexOf('account-bank-create') !== -1) {
                            this.buttonCheck.create = true
                        }
                    } else {
                        this.$router.push({name: 'home'})
                    }
                }).catch(() => {
                this.$router.push({name: 'home'})
            })
        },

    },

    computed: {
        account_banks() {
            return this.$store.state.account_bank.items
        },

        selectInput() {
            return this.$store.state.var.selectActiveInactive;
        },

        params() {
            return {
                page: this.account_banks.current_page,
                name: this.formDate.name,
                status: this.formDate.status,
            }
        },
    },

    components: {
        PainelComponent,
        ButtonOne,
        ButtonFloat,
        ButtonPagination,
        InputComponent,
        RowComponent,
        RowColComponent,
        LoderSendComponent,
        Multiselect,
        ButtonEditRound,
        ButtonShowRound
    },
}
</script>

<style src="@/assets/css/table-resp.css" scoped>

</style>

<style>
.avatar__image_2 {
    border: 1px solid #d67c1c;
    height: 30px;
    width: 30px;
    object-fit: cover;
    border-radius: 50%;
    margin-right: 10px;
}
</style>

<style scoped>
.filter-position {
    text-align: right;
    right: 0;
    position: absolute;
    top: 0;
    margin: 2%;
}

.btn-filter {
    height: 43px;
    width: 43px;
    padding: 0.7rem;
    border-radius: 50%;
    border: 0;
    outline: none;
    background-color: #d67c1c;
    color: #fff;
}

.fade-in-top-enter-active {
    -webkit-animation: fade-in-top 0.6s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
    animation: fade-in-top 0.6s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
}

.fade-in-top-leave-active {
    -webkit-animation: fade-in-top 0.6s cubic-bezier(0.390, 0.575, 0.565, 1.000) both reverse;
    animation: fade-in-top 0.6s cubic-bezier(0.390, 0.575, 0.565, 1.000) both reverse;
}

@-webkit-keyframes fade-in-top {
    0% {
        -webkit-transform: translateY(-50px);
        transform: translateY(-50px);
        opacity: 0;
    }

    100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
        opacity: 1;
    }
}

@keyframes fade-in-top {
    0% {
        -webkit-transform: translateY(-50px);
        transform: translateY(-50px);
        opacity: 0;
    }

    100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
        opacity: 1;
    }
}
</style>

